require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-campaign-derechos-para-personas-con-discapacidad.json") })
        }
      }, "path---es-mx-campaign-derechos-para-personas-con-discapacidad");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-campaign-derechos-para-personas-con-discapacidad!./.cache/json/es-mx-campaign-derechos-para-personas-con-discapacidad.json
// module id = 884
// module chunks = 231608221292675